import React from "react";
import { IonRow } from "@ionic/react";
import { Product } from "@core/types";
import classNames from "classnames/bind";

import styles from "./NewListViewProduct.module.scss";
import Rating from "./Rating";
import { WishlistButton } from "./WishlistButton";

interface DescriptionProps {
  product: Product;
  type: "list-for-wish" | "newList";
}

const cx = classNames.bind(styles);

const Description = ({ product, type }: DescriptionProps) => (
  <div>
    <IonRow>
      <Rating rating={product.averageRating} />
      <WishlistButton type={type} product={product} />
    </IonRow>
    <div className={cx("productsSpecial__description")}>{product.name}</div>
  </div>
);

export default Description;
